import { RadioQuestion } from 'app/ui/components/radio-questions-list/RadioQuestionsList';

export const PRE_CONSTRUCTION: RadioQuestion[] = [
  {
    id: 'preApprovedErosion',
    title:
      'Are the approved Erosion and Sediment Control Plan (ESCP) and DOB land disturbance permit on site?',
    subtitle: '',
    state: null,
  },

  {
    id: 'preMatchErosionPlan',
    title:
      'Do site conditions match the approved Erosion and Sediment Control plan?',
    subtitle: '',
    state: null,
  },
  {
    id: 'preAdditionalPermitsRequired',
    title:
      'Are any additional permits required (tree removal, Public Space, other)?',
    subtitle: '',
    state: null,
  },
  {
    id: 'preAdditionalControlsNeeded',
    title: 'Are additional controls or revision needed to the approved ESCP?',
    subtitle: '',
    state: null,
  },
  {
    id: 'preApprovedToInstallControls',
    title:
      'Are the ESCP owners approved to install controls as described by the approved ESCP?',
    subtitle: '',
    state: null,
  },
];

export const PRE_CONSTRUCTION_FAIL_MATRIX = [false, false, true, true, false];
export const PRE_CONSTRUCTION_FAIL_MESSAGE =
  'Based on your selected answers, the final result of the inspection is failed. Are  you sure you want to continue?';

export const POST_CONSTRUCTION: RadioQuestion[] = [
  {
    id: 'postGradedAreasStabilized',
    title:
      'Are all graded and disturbed areas fully stabilized as described by the approved ESCP?',
    subtitle: '',
    state: null,
  },

  {
    id: 'postTemporaryErosion',
    title:
      'Are all temporary erosion and sediment control best practices described on the approved plan removed?',
    subtitle: '',
    state: null,
  },
  {
    id: 'postLandscapeStabilized',
    title: 'Are all landscape areas stabilized with plant material?',
    subtitle: '',
    state: null,
  },
  {
    id: 'postAdditionalInspectionNeeded',
    title:
      'Is an additional inspection to document compliance with the approved plan needed?',
    subtitle: '',
    state: null,
  },
];

export const POST_CONSTRUCTION_FAIL_MATRIX = [false, false, false, true];
export const POST_CONSTRUCTION_FAIL_MESSAGE =
  'Based on your selected answers, the final result of the inspection is failed. Are  you sure you want to continue?';

export const COMPLIANCE: RadioQuestion[] = [
  {
    id: 'compAccordingScm',
    title:
      'Are all erosion and sediment control measures depicted on the approved plan installed according to the approved plan and the DOEE Erosion and Sediment Control Manual?',
    subtitle: '',
    state: null,
  },

  {
    id: 'compSignPosted',
    title:
      'Is a sign posted that notifies the public to contact DOEE in the event of erosion or other pollution according to 21 DCMR § 543.22.?',
    subtitle: '',
    state: null,
  },
  {
    id: 'compAdditionalInspection',
    title:
      'Is an additional inspection to document compliance with the approved plan needed?',
    subtitle: '',
    state: null,
  },
];

export const COMPLIANCE_FAIL_MATRIX = [false, false, true];
export const COMPLIANCE_FAIL_MESSAGE =
  'Based on your selected answers, the final result of the inspection is failed. Are  you sure you want to continue?';
